module.exports = __webpack_public_path__ + "static/media/black.3ca9ada6.svg";